import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-print',
  templateUrl: './modal-print.component.html',
  styleUrls: ['./modal-print.component.scss']
})
export class ModalPrintComponent implements OnInit {

  modalData: any;
  printForm: FormGroup;
  type: string;
  titleType: string;
  printData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPrintComponent>,
    private fb: FormBuilder,
  ) { this.modalData = data; }

  ngOnInit(): void {
    // console.log(this.modalData);
    this.type = this.modalData.type;
    this.printData = this.modalData.detail;
    this.getTitle();

    this.printForm = this.fb.group({
      type: ['', Validators.required],
    })
  }

  getTitle() {
    switch (this.type) {
      case 'quotation': { this.titleType = 'ใบเสนอราคา'; break; }
      case 'invoice': { this.titleType = 'ใบแจ้งหนี้'; break; }
      case 'receipt': { this.titleType = 'ใบเสร็จ'; break; }
      default: break;
    }
  }

  print(form) {
    const response = {
      status: true,
      printType: form.type,
      titleType: this.titleType,
    }
    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false
    }
    this.dialogRef.close(response);
  }

}
